import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SbLocalDateTime} from '../../../services/api/api-date-time';
import {UtilService} from '../../../services/util.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalNavigationComponent} from '../../../services/gui/modal/modal-navigation-component';
import {ModalNavigationService} from '../../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-comp-planning-time',
  templateUrl: './sb-planning-time.component.html',
  styleUrls: ['./sb-planning-time.component.scss'],
  standalone: false,
})
export class SbPlanningTimeComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;
  form: FormGroup;
  result: { name: string; description: string; from: SbLocalDateTime; till: SbLocalDateTime };

  constructor(
    public translate: TranslateService,
    public modal: ModalNavigationService,
    public util: UtilService
  ) {
    this.form = new FormGroup(
      {
        Name: new FormControl('', [Validators.required]),
        From: new FormControl('', [Validators.required]),
        Till: new FormControl('', [Validators.required]),
        Description: new FormControl('', []),
      },
      [this.util.endDateAfterStartDate]
    );
    this.result = { name: '', description: '', from: null, till: null };
  }

  ngOnInit(): void {
    this.registerFormChangesListener();
  }

  get Name() {
    return this.form.get('Name');
  }

  get From() {
    return this.form.get('From');
  }

  get Till() {
    return this.form.get('Till');
  }

  get Description() {
    return this.form.get('Description');
  }

  private registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      this.result.name = value;
    });
    this.Description.valueChanges.subscribe(value => {
      this.result.description = value;
    });
    this.From.valueChanges.subscribe(value => {
      let diff;
      if (this.result?.till?.value && this.result?.from?.value) {
        diff = this.result.till.value.diff(this.result.from.value);
      }
      this.result.from = value;
      if (this.result?.from?.value && this.result?.till?.value) {
        this.result.till = diff ? new SbLocalDateTime(this.result.from.value.plus(diff)) : this.result.from;
        setTimeout(() => {
          this.Till.setValue(this.result.till);
        }, 1);
      }
    });
    this.Till.valueChanges.subscribe(value => {
      this.result.till = value;
    });
  }

  localDateTimeInputFrom(date) {
    this.From.setValue(date);
  }

  localDateTimeInputTill(date) {
    this.Till.setValue(date);
  }

  ok() {
    if (this.isInModalContext) {
      this.modal.result(this.result);
    }
  }

  cancel() {
    if (this.isInModalContext) {
      this.modal.result(null);
    }
  }
}
